'use strict';

var _regeneratorRuntime = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _createForOfIteratorHelper = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createForOfIteratorHelper");

var _objectSpread = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/objectSpread2");

var _awaitAsyncGenerator = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncIterator");

var CID = require('cids');

var toCamelWithMetadata = require('../lib/object-to-camel-with-metadata');

var configure = require('../lib/configure');

var toUrlSearchParams = require('../lib/to-url-search-params');
/**
 * @typedef {import('../types').HTTPClientExtraOptions} HTTPClientExtraOptions
 * @typedef {import('ipfs-core-types/src/files').API<HTTPClientExtraOptions>} FilesAPI
 */


module.exports = configure(function (api) {
  /**
   * @type {FilesAPI["ls"]}
   */
  function ls(_x) {
    return _ls.apply(this, arguments);
  }

  function _ls() {
    _ls = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path) {
      var options,
          res,
          _iteratorNormalCompletion,
          _didIteratorError,
          _iteratorError,
          _iterator,
          _step,
          _value,
          result,
          _iterator2,
          _step2,
          entry,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};

              if (!(!path || typeof path !== 'string')) {
                _context.next = 3;
                break;
              }

              throw new Error('ipfs.files.ls requires a path');

            case 3:
              _context.next = 5;
              return _awaitAsyncGenerator(api.post('files/ls', {
                timeout: options.timeout,
                signal: options.signal,
                searchParams: toUrlSearchParams(_objectSpread(_objectSpread({
                  arg: CID.isCID(path) ? "/ipfs/".concat(path) : path,
                  // default long to true, diverges from go-ipfs where its false by default
                  long: true
                }, options), {}, {
                  stream: true
                })),
                headers: options.headers
              }));

            case 5:
              res = _context.sent;
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 8;
              _iterator = _asyncIterator(res.ndjson());

            case 10:
              _context.next = 12;
              return _awaitAsyncGenerator(_iterator.next());

            case 12:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 16;
              return _awaitAsyncGenerator(_step.value);

            case 16:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 44;
                break;
              }

              result = _value;

              if (!('Entries' in result)) {
                _context.next = 39;
                break;
              }

              _iterator2 = _createForOfIteratorHelper(result.Entries || []);
              _context.prev = 21;

              _iterator2.s();

            case 23:
              if ((_step2 = _iterator2.n()).done) {
                _context.next = 29;
                break;
              }

              entry = _step2.value;
              _context.next = 27;
              return toCoreInterface(toCamelWithMetadata(entry));

            case 27:
              _context.next = 23;
              break;

            case 29:
              _context.next = 34;
              break;

            case 31:
              _context.prev = 31;
              _context.t0 = _context["catch"](21);

              _iterator2.e(_context.t0);

            case 34:
              _context.prev = 34;

              _iterator2.f();

              return _context.finish(34);

            case 37:
              _context.next = 41;
              break;

            case 39:
              _context.next = 41;
              return toCoreInterface(toCamelWithMetadata(result));

            case 41:
              _iteratorNormalCompletion = true;
              _context.next = 10;
              break;

            case 44:
              _context.next = 50;
              break;

            case 46:
              _context.prev = 46;
              _context.t1 = _context["catch"](8);
              _didIteratorError = true;
              _iteratorError = _context.t1;

            case 50:
              _context.prev = 50;
              _context.prev = 51;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 55;
                break;
              }

              _context.next = 55;
              return _awaitAsyncGenerator(_iterator.return());

            case 55:
              _context.prev = 55;

              if (!_didIteratorError) {
                _context.next = 58;
                break;
              }

              throw _iteratorError;

            case 58:
              return _context.finish(55);

            case 59:
              return _context.finish(50);

            case 60:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[8, 46, 50, 60], [21, 31, 34, 37], [51,, 55, 59]]);
    }));
    return _ls.apply(this, arguments);
  }

  return ls;
});
/**
 * @param {*} entry
 */

function toCoreInterface(entry) {
  if (entry.hash) {
    entry.cid = new CID(entry.hash);
  }

  delete entry.hash;
  entry.type = entry.type === 1 ? 'directory' : 'file';
  return entry;
}